module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {}, [_c('b-form-file', {
    ref: 'file-input-' + this.input,
    attrs: {
      "disabled": _vm.disabled,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "placeholder": "Escolher arquivo...",
      "drop-placeholder": "Apagar arquivo...",
      "browse-text": "Procurar..."
    },
    on: {
      "change": _vm.handleChange
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function(ref) {
        var names = ref.names;

        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))]), _vm._v(" "), (names.length > 1) ? _c('b-badge', {
          staticClass: "ml-1",
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("\n              + " + _vm._s(names.length - 1) + " More files\n            ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), _vm._v(" "), (_vm.currentFile != null) ? _c('div', {
    staticClass: "arquivo-info"
  }, [_c('Download', {
    attrs: {
      "arquivo": _vm.currentFile
    },
    on: {
      "deleted": _vm.handleDeleted
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7069a0eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/upload.vue
// module id = 1545
// module chunks = 45